
export default {
  box: {
    responsiveBreakpoint: 'small' // when we switch rows to columns
  },
  heading: {
    responsiveBreakpoint: 'small'
  },
  layer: {
    responsiveBreakpoint: 'small'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/themes/base.js
// module id = 38
// module chunks = 0